import i18n from "../lang/base";

export const ALERTS = {
    // Type
    SUCCESS: "SUCCESS",
    ERROR: "ERR",
    WARN: "WARN",
    INFO: "INFO",
}

export const POPUP_TYPE = {
    MESSAGE_POPUP: "MESSAGE",
    MESSAGE_WITH_TITLE_POPUP: "MESSAGEWITHTITLE",
    LIST_MESSAGE_POPUP: "LISTMESSAGE",
    LIST_MESSAGE_WITH_TITLE_POPUP: "LISTMESSAGEWITHTITLE",
    LIST_MESSAGE_COMPLETE_POPUP: "LISTMESSAGECOMPLETE",
    PORTAL_MEESAGE_SEND_POPUP: "PORTALMESSAGESEND",   
}

export const EDIT_POPUP_TYPE = {
    TEXT_AREA_SEND_EDIT_POPUP: "TEXTAREA",
}

export const TABLE_ACTION_MENU_TYPE = {
    PUSH_BUTTON: "PUSH",
    CONTROL_BUTTON: "CONTROL",
    CATEGORY_CONTROL_BUTTON: "CATEGORY_CONTROL",
    ORDER_CONTROL_BUTTON: "ORDER_CONTROL",
}

export const TABLE_BUTTON_TYPE = {
    PUSH: "TPUSH",
    PUSH_WITH_ICON: "TPUSHICON",
    DARK_PUSH: "DPUSH",
    DELETE: "DEL",
    CANCEL: "CANC",
    NORMAL: "NPUSH",
}

export const TABLE_QUERY_MENU_TYPE = {
    PUSH_BUTTON: "PUSH",
    CONTROL_FILTER_BUTTON: "CONTROL_FILTER",
    CONTROL_PERIOD_BUTTON: "CONTROL_PERIOD",
    CONTROL_PERIOD_PRESET_BUTTON: "CONTROL_PRESET_PERIOD"
}


export const ERROR_CODE = {
    EMPTY_VALUE_ERROR_CODE: {
        CODE: 101,
        DETAIL: i18n.t("ERROR_CODE_EMPTY_TEXT"),
    },
    NOT_MATCHED_ERROR_CODE: {
        CODE: 102,
        DETAIL: i18n.t("ERROR_CODE_NET_MATCHED_TEXT"),
    },
    NOT_ALLOW_FORMAT_ERROR_CODE: {
        CODE: 103,
        DETAIL: i18n.t("ERROR_CODE_FORMAT_TEXT"),
    },
    DPULICATED_VALUE_ERROR_CODE: {
        CODE: 104,
        DETAIL: i18n.t("ERROR_CODE_DUPLICATE_VALUE_TEXT"),
    },
    NOT_CHECKED_EMAIL_DUPLICATE_ERROR_CODE: {
        CODE: 105,
        DETAIL: i18n.t("ERROR_CODE_NOT_CHECKED_EMAIL_DUPLICATE_TEXT"),
    },
    CONNECTION_FAILED_CODE: {
        CODE: 201,
        DETAIL: i18n.t("ERROR_CODE_CONNECTION_FAILED_TEXT"),
    }
}
